angular
  .module("AccountingBoxApp")
  .controller("ReportingVATReturnCtrl", function(
    $scope,
    $http,
    $state,
    FileUploader,
    LoopBackAuth,
    Journal,
    Rapporting
  ) {
    var vm = this;

    vm.dates = {
      startDate: moment()
        .quarter(1)
        .startOf("quarter"),
      endDate: moment().endOf("quarter")
    };

    //Watch for date changes
    $scope.$watch(
      "rvr.dates",
      function(newDate) {
        vm.dateChanged();
      },
      false
    );

    vm.dateChanged = function() {
      if (!vm.dates.startDate) return;
      vm.quarter = vm.dates.endDate.quarter();
      vm.year = vm.dates.endDate.year();
      var beginDate = vm.dates.startDate.toDate();
      var endDate = vm.dates.endDate.toDate();
      vm.loading = true;
      Rapporting.vatReturn({ beginDate: beginDate, endDate: endDate }, function(
        response
      ) {
        vm.vatReturn = response.vatReturn;
        vm.loading = false;
      });
    };

    vm.today = function() {
      return moment().format("L");
    };

    vm.generateJournalEntry = function() {
      var beginDate = vm.dates.startDate.toDate();
      var endDate = vm.dates.endDate.toDate();

      vm.generatingJournalEntry = true;
      Rapporting.generatVatReturnBooking(
        { beginDate: beginDate, endDate: endDate },
        function(result) {
          vm.generatingJournalEntry = false;
          $state.go("app.company.edit.journalEntries", {
            id: result.journalEntry.id
          });
        },
        function(error) {
          vm.generatingJournalEntry = false;
          window.swal("Mislukt", "Journalpost genereren mislukt.", "error");
        }
      );
    };
  });
